import type { ComponentProps } from 'react';

const CatInBox = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="133"
      height="179"
      viewBox="0 0 133 179"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.54"
        d="M64.8726 177C89.599 177 109.644 168.282 109.644 157.529C109.644 146.775 89.599 138.058 64.8726 138.058C40.1463 138.058 20.1016 146.775 20.1016 157.529C20.1016 168.282 40.1463 177 64.8726 177Z"
        fill="#DCD6CD"
        stroke="white"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M114.832 48.0333L65.5964 30.2448V29.6438L64.8723 30.0044L64.0276 29.6438V30.2448L14.7915 48.0333V103.803L64.8723 85.6535L114.832 103.803V48.0333Z"
        fill="#5C5751"
        stroke="white"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M66.0791 71.4706L117.005 48.634V117.865L66.0791 140.701V71.4706Z"
        fill="#948B81"
        stroke="white"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M65.5964 140.701L14.7915 117.865V48.634L65.5964 71.4706V140.701Z"
        fill="#948B81"
        stroke="white"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M99.0241 15.7014C95.8865 12.5764 95.8865 7.52831 99.0241 4.4033C101.558 1.87926 105.661 1.87926 108.196 4.4033C110.247 6.44658 110.247 9.69177 108.196 11.6148C106.627 13.1774 103.972 13.1774 102.403 11.6148C101.076 10.2927 101.076 8.24947 102.403 6.92735C103.489 5.84562 105.058 5.96581 106.144 6.92735C106.989 7.7687 106.989 9.09082 106.144 9.93216C105.541 10.5331 104.455 10.5331 103.73 9.93216"
        stroke="#948B81"
        stroke-width="1.20677"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.5498 22.4323C24.9288 19.5477 29.9972 20.0285 32.8934 23.5141C35.1863 26.2785 34.8243 30.2448 32.0487 32.5285C29.8765 34.3314 26.6182 34.091 24.8081 31.8073C23.36 30.0044 23.6013 27.4804 25.4115 26.0381C26.8596 24.8362 28.9111 25.0766 30.1179 26.5189C31.0833 27.6006 30.8419 29.2833 29.7558 30.2448C28.9111 30.966 27.5837 30.8458 26.7389 30.0044C26.1355 29.2833 26.2562 28.2016 26.9803 27.6006"
        stroke="#948B81"
        stroke-width="1.20677"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.0996 61.7355C41.0996 61.7355 46.8921 36.2547 68.6139 36.7354C84.9052 37.096 93.594 60.2932 93.594 60.2932L66.9244 69.0672L41.0996 61.7355Z"
        fill="#DCD6CD"
        stroke="#948B81"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M66.8034 67.0236L49.5466 92.1438L2 72.5524L17.5673 48.0332L66.8034 67.0236Z"
        fill="#DCD6CD"
        stroke="white"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M86.2326 29.5241L86.836 2.72116C78.63 4.52405 77.7852 11.976 77.7852 11.976C66.0796 5.48558 56.4255 11.4952 56.4255 11.4952C54.9773 3.68271 47.9781 2 47.9781 2C47.9781 2 47.4954 27.601 47.616 28.8029C47.616 28.8029 47.7367 47.3126 65.7176 47.6731C87.6807 48.2741 86.2326 29.5241 86.2326 29.5241Z"
        fill="#DCD6CD"
        stroke="#948B81"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M57.1494 11.9756L60.287 19.668L61.7352 10.293L57.1494 11.9756Z"
        fill="#948B81"
      />
      <path
        d="M64.5098 10.0532L66.9233 20.6301L69.8195 10.0532H64.5098Z"
        fill="#948B81"
      />
      <path
        d="M78.0271 12.8172L74.1655 18.947L73.4414 11.0143L78.0271 12.8172Z"
        fill="#948B81"
      />
      <path
        d="M76.2172 37.8174C66.8044 29.0433 57.3916 36.8559 57.3916 36.8559C57.3916 36.8559 59.8051 40.3414 66.4424 40.8222C73.2002 41.303 76.2172 37.8174 76.2172 37.8174Z"
        fill="white"
      />
      <path
        d="M71.3894 38.1774C71.148 38.2976 70.9067 38.0572 70.786 37.8168C70.6653 37.5765 70.9067 37.3361 71.148 37.2159L79.5954 34.5716C79.8367 34.4514 80.0781 34.6918 80.1988 34.9322C80.3195 35.1726 80.0781 35.413 79.8368 35.5332L71.3894 38.1774Z"
        fill="#948B81"
      />
      <path
        d="M82.7326 31.9277C82.4913 31.6873 82.2499 31.6873 82.0085 31.9277L79.1123 34.8123C79.1123 34.8123 79.233 34.8123 79.233 34.9325C79.4743 35.0527 79.7157 35.2931 79.9571 35.4133L82.7326 32.6489C82.974 32.5287 82.974 32.1681 82.7326 31.9277Z"
        fill="#948B81"
      />
      <path
        d="M80.0785 42.0236C80.1992 41.7832 80.1992 41.4226 79.9579 41.3024L76.5789 39.0188C76.5789 39.0188 76.5789 39.139 76.4582 39.139C76.3375 39.3793 76.2169 39.6197 76.0962 39.8601L79.3545 42.0236C79.7165 42.2639 79.9578 42.2639 80.0785 42.0236Z"
        fill="#948B81"
      />
      <path
        d="M76.8193 39.9808C76.8193 39.6202 76.5779 39.3799 76.5779 39.0193L71.6302 38.7789C71.3888 38.7789 71.1475 39.0193 71.1475 39.2597C71.1475 39.5001 71.3888 39.7404 71.6302 39.7404L76.8193 39.9808Z"
        fill="#948B81"
      />
      <path
        d="M60.7707 38.2982C61.012 38.178 61.2534 38.4184 61.3741 38.6588C61.4947 38.8992 61.2534 39.1396 61.0121 39.2598L52.5647 41.904C52.3233 42.0242 52.082 41.7838 51.9613 41.5434C51.8406 41.3031 52.082 41.0627 52.3233 40.9425L60.7707 38.2982Z"
        fill="#948B81"
      />
      <path
        d="M49.4271 44.4279C49.6685 44.6683 49.9098 44.6683 50.1512 44.4279L53.0474 41.5433C53.0474 41.5433 52.9267 41.5433 52.9267 41.4231C52.6854 41.3029 52.444 41.0625 52.2027 40.9424L49.4271 43.7068C49.1858 43.9472 49.1858 44.3077 49.4271 44.4279Z"
        fill="#948B81"
      />
      <path
        d="M51.9611 34.4522C51.8404 34.6925 51.8404 35.0531 52.0818 35.1733L55.4607 37.457C55.4607 37.457 55.4607 37.3368 55.5814 37.3368C55.7021 37.0964 55.8227 36.856 55.9434 36.6156L52.6852 34.4522C52.4438 34.2118 52.2025 34.2118 51.9611 34.4522Z"
        fill="#948B81"
      />
      <path
        d="M55.3403 36.4953C55.3403 36.8558 55.5817 37.0962 55.5817 37.4568L60.5295 37.6972C60.7708 37.6972 61.0122 37.4568 61.0122 37.2164C61.0122 36.976 60.7708 36.7357 60.5295 36.7357L55.3403 36.4953Z"
        fill="#948B81"
      />
      <path
        d="M73.8039 41.3029C71.9937 41.7837 70.6663 41.6635 69.7009 40.9424C68.2527 39.8606 68.0114 37.9375 68.0114 37.5769L68.7354 36.6154L65.5978 36.4952L66.4426 37.6971C66.0805 39.5 65.3565 40.5818 64.3911 41.0626C62.5809 41.9039 60.4087 40.702 60.4087 40.702C60.0467 40.4616 59.564 40.702 59.4433 40.9424C59.3227 41.1827 59.4433 41.7837 59.6847 41.9039C59.8054 42.0241 62.5809 43.4664 64.9944 42.2645C65.9599 41.7837 66.6839 41.0625 67.1666 39.9808C67.5287 40.7019 68.0114 41.4231 68.7354 41.9039C69.5802 42.5048 70.5456 42.7452 71.7523 42.8654C72.4764 42.8654 73.3211 42.7452 74.1659 42.5048C74.5279 42.3847 74.7693 42.0241 74.6486 41.6635C74.6486 41.4231 74.1659 41.1827 73.8039 41.3029Z"
        fill="#948B81"
      />
      <path
        d="M59.3222 29.5243C59.7221 29.5243 60.0463 29.2014 60.0463 28.8031C60.0463 28.4048 59.7221 28.082 59.3222 28.082C58.9223 28.082 58.5981 28.4048 58.5981 28.8031C58.5981 29.2014 58.9223 29.5243 59.3222 29.5243Z"
        stroke="#948B81"
        stroke-width="2.41353"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.9233 29.5243C74.3232 29.5243 74.6473 29.2014 74.6473 28.8031C74.6473 28.4048 74.3232 28.082 73.9233 28.082C73.5234 28.082 73.1992 28.4048 73.1992 28.8031C73.1992 29.2014 73.5234 29.5243 73.9233 29.5243Z"
        stroke="#948B81"
        stroke-width="2.41353"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M65.5967 67.0236L82.8535 92.1438L130.4 72.5524L114.833 48.0332L65.5967 67.0236Z"
        fill="#DCD6CD"
        stroke="white"
        stroke-width="2.41353"
        stroke-miterlimit="10"
      />
      <path
        d="M81.7673 56.5669C77.785 62.216 80.1985 57.0477 85.6289 65.5814C86.715 67.2641 88.4045 68.466 90.3353 67.7448C91.3007 67.3842 92.0248 66.6631 92.3868 65.8217C92.5075 65.8217 92.7489 65.8217 92.8695 65.9419C92.8695 65.9419 92.8695 65.9419 92.8695 66.0621C93.5936 67.9852 95.6451 68.9467 97.5759 68.2256C99.5068 67.5044 100.472 65.4612 99.7481 63.5381C100.714 64.0189 101.8 64.2593 102.886 63.7785C104.817 63.0573 105.782 61.0141 105.058 59.091C104.575 57.6487 90.9387 43.7063 81.7673 56.5669Z"
        fill="#DCD6CD"
        stroke="#948B81"
        stroke-width="2.41353"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.0989 56.5669C52.0812 62.216 49.6677 57.0477 44.2372 65.5814C43.1511 67.2641 41.4617 68.466 39.5308 67.7448C38.5654 67.3842 37.8414 66.6631 37.4793 65.8217C37.3586 65.8217 37.1173 65.8217 36.9966 65.9419C36.9966 65.9419 36.9966 65.9419 36.9966 66.0621C36.2726 67.9852 34.2211 68.9467 32.2902 68.2256C30.3594 67.5044 29.394 65.4612 30.118 63.5381C29.1526 64.0189 28.0665 64.2593 26.9804 63.7785C25.0496 63.0573 24.0842 61.0141 24.8083 59.091C25.291 57.6487 38.9274 43.7063 48.0989 56.5669Z"
        fill="#DCD6CD"
        stroke="#948B81"
        stroke-width="2.41353"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M57.3911 63.418C57.3911 63.418 56.0636 54.8844 64.3903 54.644C72.8377 54.4036 76.096 54.0431 76.82 62.6969L65.5971 67.0238L57.3911 63.418Z"
        fill="white"
      />
      <path
        d="M82.8531 44.5477L81.043 51.9996L86.7148 47.7929L82.8531 44.5477Z"
        fill="#948B81"
      />
      <path
        d="M47.374 49.2352L54.856 50.4371L50.2703 45.1487L47.374 49.2352Z"
        fill="#948B81"
      />
      <path
        d="M99.7479 124.475L90.0938 128.562V107.528L99.7479 103.321V124.475Z"
        fill="#5C5751"
      />
      <path
        d="M32.5312 124.475L42.1854 128.562V107.528L32.5312 103.321V124.475Z"
        fill="#5C5751"
      />
    </svg>
  );
};

export default CatInBox;
